/**
 * @generated SignedSource<<822ccf854b372b0c0c7068f241678a61>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type siteNavigation_AtlassianHubAppShell$data = {
  readonly siteTree: {
    readonly root: {
      readonly contents: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "HelpCenterFolder";
          readonly contents: {
            readonly nodes: ReadonlyArray<{
              readonly __typename: "HelpCenterPage";
              readonly id: string;
              readonly name: {
                readonly default: string;
              } | null;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            }>;
          };
          readonly id: string;
          readonly name: {
            readonly default: string;
          } | null;
        } | {
          readonly __typename: "HelpCenterPage";
          readonly id: string;
          readonly name: {
            readonly default: string;
          } | null;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        }>;
      };
    } | null;
  } | null;
  readonly " $fragmentType": "siteNavigation_AtlassianHubAppShell";
};
export type siteNavigation_AtlassianHubAppShell$key = {
  readonly " $data"?: siteNavigation_AtlassianHubAppShell$data;
  readonly " $fragmentSpreads": FragmentRefs<"siteNavigation_AtlassianHubAppShell">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "concreteType": "HelpCenterPageName",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": (v3/*: any*/)
    }
  ],
  "type": "HelpCenterPage"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "siteNavigation_AtlassianHubAppShell",
  "selections": [
    {
      "concreteType": "HelpCenterSiteTree",
      "kind": "LinkedField",
      "name": "siteTree",
      "plural": false,
      "selections": [
        {
          "concreteType": "HelpCenterFolder",
          "kind": "LinkedField",
          "name": "root",
          "plural": false,
          "selections": [
            {
              "args": (v0/*: any*/),
              "concreteType": "HelpCenterSiteTreeNodeConnection",
              "kind": "LinkedField",
              "name": "contents",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    (v4/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v2/*: any*/),
                        {
                          "concreteType": "HelpCenterFolderName",
                          "kind": "LinkedField",
                          "name": "name",
                          "plural": false,
                          "selections": (v3/*: any*/)
                        },
                        {
                          "args": (v0/*: any*/),
                          "concreteType": "HelpCenterSiteTreeNodeConnection",
                          "kind": "LinkedField",
                          "name": "contents",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "nodes",
                              "plural": true,
                              "selections": [
                                (v1/*: any*/),
                                (v4/*: any*/)
                              ]
                            }
                          ],
                          "storageKey": "contents(first:100)"
                        }
                      ],
                      "type": "HelpCenterFolder"
                    }
                  ]
                }
              ],
              "storageKey": "contents(first:100)"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpCenter"
};
})();

(node as any).hash = "060f1a67457eba4970791c6346dc90c5";

export default node;
